export type Action = 'ACTION_EDIT' | 'ACTION_DELETE' | 'ACTION_VIEW' | 'ACTION' | 'ACTION_EDIT_SUBMIT' | 'ACTION_SELECTED' | 'ACTION_SWITCH' | 'ACTION_FINISH';

export type Order = 'asc' | 'desc';

export type viewAttributeBoolean = {
  primaryLabel: string;
  secundaryLabel: string;
}

export interface HeadCell {
  id: string;
  label: string;
  format?: Array<'date' | 'dateTime' | 'monetary'>;
  viewAttributeBoolean?: viewAttributeBoolean;
  align?: 'left' | 'center' | 'right';
}

export const ACTION_EDIT_SUBMIT = 'ACTION_EDIT_SUBMIT';
export const ACTION_EDIT = 'ACTION_EDIT';
export const ACTION_DELETE = 'ACTION_DELETE';
export const ACTION_VIEW = 'ACTION_VIEW';
export const ACTION_SELECTED = 'ACTION_SELECTED';
export const ACTION_SWITCH = 'ACTION_SWITCH';
export const ACTION_FINISH = 'ACTION_FINISH';
export const ACTION = 'ACTION';
export const ASC = 'asc';
export const DESC = 'desc';
